/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { capitalize } from 'lodash';

import { ObjectMap } from '../../types/utils/ObjectMap';
import { ApiValidationState } from '../../utils/useApiValidation';

export const concatenateApiErrors = (validation: ApiValidationState<ObjectMap>) => {
  let errorMessage = '';

  for (const key in validation.apiErrors) {
    // eslint-disable-next-line no-prototype-builtins
    if (validation.apiErrors.hasOwnProperty(key)) {
      errorMessage += `${capitalize(validation.apiErrors[key])}.\n`;
    }
  }

  return errorMessage.trim();
};
